export default __webpack_public_path__ + "static/media/Res_Amazon-VPC_Internet-Gateway_48_Light.c5ebde63.svg";